/*
  11.11 Time Attack — API-driven (N-round slot support)
  Endpoint: /api/v2/time-attack/today
  States: pre → live → closing → waiting → (live → closing → waiting …) → closed
  Inventory: daily_shared — all slots share the same stock, no refill between slots.
*/
(function () {
  'use strict';

  var API_URL = 'https://verish-api.lukuku.co/api/v2/time-attack/today';
  var POLL_INTERVAL = 10000;
  var DEBUG_LIVE = new URLSearchParams(window.location.search).get('debug_live') === '1';
  var el = document.getElementById('timeAttack');
  if (!el) return;

  var tabs = el.querySelectorAll('[data-round-tab]');
  var statusEl = el.querySelector('[data-ta-status]');
  var hrEl = el.querySelector('[data-ta-hr]');
  var minEl = el.querySelector('[data-ta-min]');
  var secEl = el.querySelector('[data-ta-sec]');
  var stockEl = el.querySelector('[data-ta-stock]');
  var errorEl = el.querySelector('[data-ta-error]');
  var loginEl = el.querySelector('[data-ta-login]');
  var dynamicGrid = el.querySelector('[data-ta-products-grid]');
  var loadingEl = el.querySelector('[data-ta-loading]');
  var slotsEl = el.querySelector('[data-ta-slots]');

  var serverOffset = 0;
  var pollTimer = null;
  var countdownTimer = null;
  var productCache = {};
  var swatchCache = {};
  var productRenderGeneration = 0;
  var storefrontRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currentData = null;
  var userSelectedTab = -1;
  var rawFetch = window.__foxThemeRawFetch || window.fetch;

  // i18n
  var lang = window.PROMO_LANG || 'en';
  var i18nAll = window.PROMO_I18N || {};
  var t = i18nAll[lang] || i18nAll['en'] || {};
  function tr(key, fallback) { return t[key] || fallback || key; }

  // Apply translations to Liquid-rendered elements with data-i18n
  el.querySelectorAll('[data-i18n]').forEach(function (node) {
    var key = node.dataset.i18n;
    if (t[key]) node.textContent = t[key];
  });

  function pad(n) { return String(n).padStart(2, '0'); }
  function serverNow() { return Date.now() + serverOffset; }
  function today() {
    var gmt8 = new Date(serverNow() + (8 * 60 * 60 * 1000));
    return gmt8.toISOString().slice(0, 10);
  }

  function formatDate(isoStr) {
    if (!isoStr) return '';
    var utcMs = new Date(isoStr).getTime();
    var gmt8 = new Date(utcMs + (8 * 60 * 60 * 1000));
    var m = gmt8.getUTCMonth() + 1, day = gmt8.getUTCDate();
    var hr = pad(gmt8.getUTCHours()), min = pad(gmt8.getUTCMinutes());
    return m + '/' + day + ' ' + hr + ':' + min + ' (GMT+8)';
  }

  function formatDateShort(isoStr) {
    if (!isoStr) return '';
    var utcMs = new Date(isoStr).getTime();
    var gmt8 = new Date(utcMs + (8 * 60 * 60 * 1000));
    return (gmt8.getUTCMonth() + 1) + '/' + gmt8.getUTCDate();
  }

  function formatTime(isoStr) {
    if (!isoStr) return '';
    var utcMs = new Date(isoStr).getTime();
    var gmt8 = new Date(utcMs + (8 * 60 * 60 * 1000));
    return pad(gmt8.getUTCHours()) + ':' + pad(gmt8.getUTCMinutes());
  }

  function findNextUpcoming(data) {
    // Prefer today's nextOpenAt from the active round
    if (data && data.round && data.round.nextOpenAt) return { openAt: data.round.nextOpenAt };
    if (!data || !data.upcoming) return null;
    var td = today();
    for (var i = 0; i < data.upcoming.length; i++) {
      var u = data.upcoming[i];
      if (u.date > td || (u.date === td && u.openAt && new Date(u.openAt).getTime() > serverNow())) return u;
    }
    return null;
  }

  function getCountry() {
    if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    try {
      var match = document.cookie.match(/(?:^|;\s*)localization=([^;]+)/);
      if (match) return decodeURIComponent(match[1]).trim().toUpperCase();
    } catch (e) {}
    return '';
  }

  function formatMoney(cents) {
    var fmt = (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat) || '${{amount}}';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, fmt);
    }
    var val = cents / 100;
    var amountDot = val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amountComma = val.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDecDot = Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecComma = Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecComma)
      .replace('{{amount_with_apostrophe_separator}}', val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace('{{amount_no_decimals}}', noDecDot)
      .replace('{{amount}}', amountDot);
  }

  function fetchData() {
    var country = getCountry();
    var url = API_URL + (country ? '?country=' + encodeURIComponent(country) : '');
    return rawFetch(url)
      .then(function (r) { if (!r.ok) throw new Error('API ' + r.status); return r.json(); })
      .then(function (data) {
        if (data.serverTime) serverOffset = new Date(data.serverTime).getTime() - Date.now();
        currentData = data;
        return data;
      });
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (!handle) return Promise.resolve(null);
    return rawFetch(storefrontRoot + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (!r.ok) {
          // Draft product returns 404 — don't treat as permanent error
          if (r.status === 404) return null;
          throw new Error(r.status);
        }
        return r.json();
      })
      .then(function (d) { if (d) productCache[handle] = d; return d; })
      .catch(function (e) { console.error('[ta] product fetch fail:', handle, e); return null; });
  }

  // Render native swatches in source-product context so Shopify swatch metadata,
  // theme settings, images and markup stay identical to ordinary product cards.
  function fetchNativeSwatches(handle) {
    if (!handle) return Promise.resolve('');
    if (swatchCache[handle]) return swatchCache[handle];
    swatchCache[handle] = rawFetch(storefrontRoot + 'products/' + encodeURIComponent(handle) + '?section_id=ta-product-swatches')
      .then(function (response) {
        if (!response.ok) throw new Error('Native swatches unavailable');
        return response.text();
      })
      .then(function (html) {
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ta-native-swatches]');
        if (!section) throw new Error('Native swatch section missing');
        return section.innerHTML;
      })
      .catch(function () {
        delete swatchCache[handle];
        // Keep the product usable without inventing substitute colors; retry next poll.
        return '';
      });
    return swatchCache[handle];
  }

  function fetchProductPresentation(product) {
    var handle = product.sourceHandle || product.source_handle;
    return Promise.all([fetchProduct(handle), fetchNativeSwatches(handle)]).then(function (result) {
      return { api: product, shopify: result[0], swatches: result[1] };
    });
  }

  function initNativeSwatches() {
    if (window.FoxTheme && typeof window.FoxTheme.initPcardSwatches === 'function') {
      window.FoxTheme.initPcardSwatches('#timeAttack [data-swatches-slider]');
    }
  }
  document.addEventListener('DOMContentLoaded', initNativeSwatches, { once: true });

  function replaceProductGrid(html) {
    productRenderGeneration += 1;
    if (dynamicGrid) {
      dynamicGrid.querySelectorAll('[data-swatches-slider]').forEach(function (slider) {
        if (slider.swiper) slider.swiper.destroy(true, true);
      });
      dynamicGrid.innerHTML = html;
    }
    return productRenderGeneration;
  }

  function showError(msg) { if (errorEl) { errorEl.textContent = msg || ''; errorEl.style.display = msg ? '' : 'none'; } }
  function showLogin(show) { if (loginEl) loginEl.style.display = show ? '' : 'none'; }
  function showLoading(show) { if (loadingEl) { if (show) loadingEl.removeAttribute('hidden'); else loadingEl.setAttribute('hidden', ''); } }
  function showAll() { el.querySelectorAll('.ta-countdown, .ta-rounds, .ta-products').forEach(function (e) { e.style.display = ''; }); }

  // --- Determine effective state considering slots ---
  function getEffectiveState(round) {
    if (DEBUG_LIVE) return 'live';
    var state = round.state;
    if (state === 'closed' && round.nextSlotId && round.nextOpenAt) {
      return 'waiting';
    }
    return state;
  }

  // --- Render slot schedule chips ---
  function renderSlots(round) {
    if (!slotsEl) return;
    var slots = round.slots;
    if (!slots || slots.length <= 1) { slotsEl.innerHTML = ''; return; }

    var currentId = round.currentSlotId;
    var html = '<div class="ta-slots__label">' + tr('schedule_today', 'Today\u2019s schedule') + '</div>';
    html += '<div class="ta-slots__list">';
    slots.forEach(function (slot) {
      var openTime = formatTime(slot.openAt);
      var closeTime = formatTime(slot.displayCloseAt || slot.closeAt);
      var cls = 'ta-slot';
      if (slot.id === currentId) cls += ' is-current';
      if (slot.state === 'closed') cls += ' is-past';
      if (slot.state === 'live') cls += ' is-live';
      html += '<span class="' + cls + '">' + openTime + '\u2013' + closeTime + '</span>';
    });
    html += '</div>';
    slotsEl.innerHTML = html;
  }

  // --- Render product cards ---
  function renderProductCards(round) {
    if (!dynamicGrid || !round.products || !round.products.length) {
      showLoading(false);
      if (dynamicGrid) replaceProductGrid('<p class="ta-products__empty">' + tr('no_products', 'No products available.') + '</p>');
      return Promise.resolve();
    }
    showLoading(true);
    var generation = replaceProductGrid('');
    var state = getEffectiveState(round);
    var cap = round.capPerVariant || 11;

    return Promise.all(round.products.map(fetchProductPresentation)).then(function (items) {
      if (generation !== productRenderGeneration) return;
      showLoading(false);
      replaceProductGrid('');
      items.forEach(function (item) {
        if (!item.shopify) return;
        var p = item.api, sp = item.shopify;
        var img = sp.featured_image || (sp.images && sp.images[0] ? sp.images[0] : '');
        if (typeof img === 'object' && img.src) img = img.src;
        var price = sp.variants && sp.variants[0] ? sp.variants[0].price : 0;
        var comparePrice = sp.variants && sp.variants[0] ? sp.variants[0].compare_at_price : null;
        var totalAvail = 0;
        if (p.variants) p.variants.forEach(function (v) { totalAvail += (v.available || 0); });

        // Button state: only allow purchase when live AND purchasable
        var btnClass = 'ta-products__btn';
        var btnText = '';
        var capText = cap + ' ' + tr('units_per_day', 'units shared across all rounds today');
        var isLiveAndPurchasable = state === 'live' && (DEBUG_LIVE || p.purchasable) && (DEBUG_LIVE || totalAvail > 0);

        if (isLiveAndPurchasable) {
          btnClass += ' is-live';
          btnText = tr('add_extra', 'ADD - EXTRA 11%');
          capText = '';
        } else if (state === 'live' && (p.soldOut || totalAvail <= 0)) {
          btnClass += ' is-sold';
          btnText = tr('sold_out', 'SOLD OUT');
          capText = '';
        } else if (state === 'waiting') {
          btnClass += ' is-closed';
          btnText = tr('slot_closed', 'THIS ROUND CLOSED');
          capText = '';
        } else if (state === 'closing') {
          btnClass += ' is-closed';
          btnText = tr('closing', 'CLOSING');
          capText = '';
        } else if (state === 'closed') {
          btnClass += ' is-closed';
          btnText = tr('card_closed', 'CLOSED');
          capText = '';
        } else {
          // pre state — show dynamic open time
          var openTime = '';
          if (round.slots && round.slots.length > 0) {
            var firstOpen = round.slots.find(function (s) { return s.state !== 'closed'; });
            if (firstOpen) openTime = formatTime(firstOpen.openAt);
          }
          if (!openTime && round.openAt) openTime = formatTime(round.openAt);
          btnText = openTime ? tr('opens_at', 'OPENS {time}').replace('{time}', openTime) : tr('opens_soon', 'OPENS SOON');
        }

        var disc = '';
        if (comparePrice && comparePrice > price)
          disc = Math.round((1 - price / comparePrice) * 100) + '%';

        // URL: live → clone PDP, otherwise → original product
        var isLive = state === 'live';
        var url = (isLive && p.taHandle) ? '/products/' + p.taHandle : '/products/' + sp.handle;

        // TA extra 11% off price
        var taPrice = Math.round(price * 0.89);
        var showTaPrice = price > 0;
        var taDisc = '';
        if (showTaPrice && comparePrice && comparePrice > 0)
          taDisc = Math.round((1 - taPrice / comparePrice) * 100) + '%';
        else if (showTaPrice && price > 0)
          taDisc = '11%';

        var swatchesHtml = item.swatches;
        var onSale = comparePrice && comparePrice > price;
        var card = document.createElement('div');
        card.className = 'ta-products__item product-card';
        card.setAttribute('data-prod-card', '');

        // Price HTML: during live show 3-tier (original / sale / TA price)
        var priceHtml = '';
        if (showTaPrice) {
          priceHtml =
            '<div class="ta-price-3tier">' +
              '<div class="ta-price-3tier__row-pc">' +
                (onSale ? '<span class="ta-price-3tier__original"><s>' + formatMoney(comparePrice) + '</s></span>' : '') +
                '<span class="ta-price-3tier__sale"><s>' + formatMoney(price) + '</s></span>' +
              '</div>' +
              '<div class="ta-price-3tier__final">' + formatMoney(taPrice) + '</div>' +
              '<div class="ta-price-3tier__col-mo">' +
                '<div class="ta-price-3tier__final">' + formatMoney(taPrice) + '</div>' +
                '<div class="ta-price-3tier__sale"><s>' + formatMoney(price) + '</s></div>' +
                (onSale ? '<div class="ta-price-3tier__original"><s>' + formatMoney(comparePrice) + '</s></div>' : '') +
              '</div>' +
            '</div>';
        } else {
          priceHtml =
            '<div class="f-price f-price--center' + (onSale ? ' f-price--on-sale' : '') + '">' +
              '<div class="f-price__regular"><span class="f-price-item f-price-item--regular">' + formatMoney(price) + '</span></div>' +
              (onSale
                ? '<div class="f-price__sale"><span class="f-price-item f-price-item--sale">' + formatMoney(price) + '</span>' +
                  '<span class="f-price-item f-price-item--regular"><s>' + formatMoney(comparePrice) + '</s></span></div>'
                : '') +
            '</div>';
        }

        card.innerHTML =
          '<div class="product-card__inner">' +
            '<a href="' + url + '" class="ta-pcard__media">' +
              (img ? '<img data-product-image-main class="ta-pcard__img" src="' + img + '" alt="' + (sp.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
              ((showTaPrice && taDisc) ? '<span class="ta-pcard__badge">' + taDisc + '</span>' : (disc ? '<span class="ta-pcard__badge">' + disc + '</span>' : '')) +
              (state === 'closed' ? '<div class="ta-pcard__closed-overlay"><span>' + tr('card_closed', 'CLOSED') + '</span></div>' : '') +
            '</a>' +
            '<div class="product-card__info text-center">' +
              '<h3 class="product-card__title text-pcard-title">' +
                '<a class="reversed-link" href="' + url + '"><span>' + (sp.title || '') + '</span></a>' +
              '</h3>' +
              priceHtml +
              swatchesHtml +
            '</div>' +
          '</div>' +
          '<div class="ta-products__cta">' +
            (isLiveAndPurchasable
              ? '<a href="' + url + '" class="' + btnClass + '" data-ta-btn>' + btnText + '</a>'
              : '<div class="' + btnClass + '" data-ta-btn>' + btnText + '</div>') +
            '<p class="ta-products__cap-text" data-ta-cap-text>' + capText + '</p>' +
          '</div>';
        dynamicGrid.appendChild(card);
      });

      initNativeSwatches();
      if (dynamicGrid) dynamicGrid.scrollLeft = 0;
      if (typeof updateNavState === 'function') updateNavState();
    });
  }

  var EVENT_END_MS = new Date('2026-11-16T11:32:00+08:00').getTime();

  function render(data) {
    showError('');
    showLogin(false);
    if (data.eligible === false) { window.location.href = '/'; return; }
    showAll();

    if (serverNow() >= EVENT_END_MS) {
      clearInterval(countdownTimer);
      clearInterval(pollTimer);
      el.style.display = 'none';
      return;
    }

    // Find which tab to show
    var activeTabIndex = -1;
    if (data.round && data.round.date) {
      var rangeMatch = -1;
      for (var i = 0; i < tabs.length; i++) {
        var s = tabs[i].dataset.roundStart, e = tabs[i].dataset.roundEnd;
        if (s === data.round.date && e === data.round.date) { activeTabIndex = i; break; }
        if (rangeMatch < 0 && s && e && data.round.date >= s && data.round.date <= e) rangeMatch = i;
      }
      if (activeTabIndex < 0) activeTabIndex = rangeMatch;
      if (activeTabIndex < 0) activeTabIndex = 0;
    }
    if (activeTabIndex < 0) {
      var td = today();
      for (var j = 0; j < tabs.length; j++) {
        var te = tabs[j].dataset.roundEnd;
        if (te && te >= td) { activeTabIndex = j; break; }
      }
    }
    if (activeTabIndex < 0 && tabs.length) activeTabIndex = 0;

    var displayTab = userSelectedTab >= 0 ? userSelectedTab : activeTabIndex;
    tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === displayTab); });
    showTabContent(displayTab);
  }

  var lastRenderedState = null;

  function startCountdown(round, state) {
    clearInterval(countdownTimer);

    // closing: countdown to closeAt (grace period end)
    // no early return — let tick() handle it

    function tick() {
      var now = serverNow(), diff = 0;
      if (state === 'pre' && round.openAt) {
        diff = Math.max(0, Math.floor((new Date(round.openAt).getTime() - now) / 1000));
      } else if (state === 'live' && round.displayCloseAt) {
        diff = Math.max(0, Math.floor((new Date(round.displayCloseAt).getTime() - now) / 1000));
      } else if (state === 'waiting' && round.nextOpenAt) {
        diff = Math.max(0, Math.floor((new Date(round.nextOpenAt).getTime() - now) / 1000));
      } else if (state === 'closing' && round.closeAt) {
        diff = Math.max(0, Math.floor((new Date(round.closeAt).getTime() - now) / 1000));
      }

      if (diff <= 0) {
        if (hrEl) hrEl.textContent = '00'; if (minEl) minEl.textContent = '00'; if (secEl) secEl.textContent = '00';
        clearInterval(countdownTimer);
        var boundaryKey = state + ':' + (state === 'closing' ? round.closeAt : state === 'live' ? round.displayCloseAt : state === 'waiting' ? round.nextOpenAt : round.openAt);
        if (lastRenderedState !== boundaryKey) {
          lastRenderedState = boundaryKey;
          fetchAndRender();
        }
        return;
      }
      if (hrEl) hrEl.textContent = pad(Math.floor(diff / 3600));
      if (minEl) minEl.textContent = pad(Math.floor((diff % 3600) / 60));
      if (secEl) secEl.textContent = pad(diff % 60);
    }
    countdownTimer = setInterval(tick, 1000);
    tick();
  }

  function fetchAndRender() {
    fetchData().then(function (d) { render(d); }).catch(function (e) {
      productRenderGeneration += 1;
      console.error('[ta]', e);
      showLoading(false);
      showAll();
      // API error — clear purchasable state, don't keep stale data
      if (statusEl) { statusEl.textContent = tr('opens_soon', 'OPENS SOON'); statusEl.className = 'ta-countdown__label'; }
      if (hrEl) hrEl.textContent = '--'; if (minEl) minEl.textContent = '--'; if (secEl) secEl.textContent = '--';
      if (stockEl) stockEl.textContent = '';
      // Disable all purchase buttons on error
      if (dynamicGrid) {
        dynamicGrid.querySelectorAll('[data-ta-btn]').forEach(function (btn) {
          btn.classList.remove('is-live');
          btn.classList.add('is-closed');
          if (btn.tagName === 'A') {
            var div = document.createElement('div');
            div.className = btn.className;
            div.textContent = tr('opens_soon', 'OPENS SOON');
            btn.parentNode.replaceChild(div, btn);
          } else {
            btn.textContent = tr('opens_soon', 'OPENS SOON');
          }
        });
      }
    });
  }

  // --- Tab click: show that tab's round data ---
  function findDataForTab(tabIndex, data) {
    if (!data) return null;
    var tab = tabs[tabIndex];
    var start = tab.dataset.roundStart;
    var end = tab.dataset.roundEnd;
    if (!start || !end) return null;

    if (data.round && data.round.date >= start && data.round.date <= end) {
      var hasBetterTab = false;
      for (var t = 0; t < tabs.length; t++) {
        if (t === tabIndex) continue;
        var ts = tabs[t].dataset.roundStart, te = tabs[t].dataset.roundEnd;
        if (ts === data.round.date && te === data.round.date) { hasBetterTab = true; break; }
      }
      if (!hasBetterTab) return { type: 'active', round: data.round };
    }
    if (data.upcoming) {
      for (var i = 0; i < data.upcoming.length; i++) {
        var u = data.upcoming[i];
        var uEnd = u.endDate || u.end_date || u.date;
        // Range overlap: upcoming [u.date, uEnd] overlaps tab [start, end]
        if (u.date >= start && u.date <= end && uEnd >= start && uEnd <= end) return { type: 'upcoming', round: u };
        if (u.date >= start && u.date <= end) return { type: 'upcoming', round: u };
        if (uEnd >= start && uEnd <= end) return { type: 'upcoming', round: u };
      }
    }
    if (end < today()) return { type: 'past' };
    if (data.round) return { type: 'active', round: data.round };
    return null;
  }

  function renderUpcomingProducts(upcomingRound) {
    if (!dynamicGrid) return;
    var products = upcomingRound.products || [];
    if (!products.length) {
      showLoading(false);
      replaceProductGrid('<p class="ta-products__empty">' + tr('products_soon', 'Products will be announced soon.') + '</p>');
      return;
    }
    showLoading(true);
    var generation = replaceProductGrid('');
    return Promise.all(products.map(fetchProductPresentation)).then(function (items) {
      if (generation !== productRenderGeneration) return;
      showLoading(false);
      replaceProductGrid('');
      var cap = upcomingRound.capPerVariant || upcomingRound.cap_per_variant || 11;

      // Determine open time from slots or openAt
      var openTime = '';
      if (upcomingRound.slots && upcomingRound.slots.length > 0) {
        openTime = formatTime(upcomingRound.slots[0].openAt);
      } else if (upcomingRound.openAt) {
        openTime = formatTime(upcomingRound.openAt);
      }
      var btnText = openTime ? tr('opens_at', 'OPENS {time}').replace('{time}', openTime) : tr('opens_soon', 'OPENS SOON');

      products.forEach(function (p, idx) {
        var sp = items[idx].shopify;
        if (!sp) return;
        var img = '';
        if (p.sourceImage && p.sourceImage.url) img = p.sourceImage.url;
        else {
          img = sp.featured_image || (sp.images && sp.images[0] ? sp.images[0] : '');
          if (typeof img === 'object' && img.src) img = img.src;
        }
        var title = p.sourceTitle || sp.title || '';
        var swatchesHtml = items[idx].swatches;
        var card = document.createElement('div');
        card.className = 'ta-products__item product-card';
        card.setAttribute('data-prod-card', '');
        card.innerHTML =
          '<div class="product-card__inner">' +
            '<a class="ta-pcard__media">' +
              (img ? '<img data-product-image-main class="ta-pcard__img" src="' + img + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="product-card__info text-center">' +
              '<h3 class="product-card__title text-pcard-title"><span>' + title + '</span></h3>' +
              swatchesHtml +
            '</div>' +
          '</div>' +
          '<div class="ta-products__cta">' +
            '<div class="ta-products__btn" data-ta-btn>' + btnText + '</div>' +
          '</div>';
        dynamicGrid.appendChild(card);
      });
      initNativeSwatches();
      if (dynamicGrid) dynamicGrid.scrollLeft = 0;
      if (typeof updateNavState === 'function') updateNavState();
    });
  }

  function showTabContent(tabIndex) {
    if (!currentData) return;
    var match = findDataForTab(tabIndex, currentData);

    if (!match) {
      showLoading(false);
      if (dynamicGrid) replaceProductGrid('<p class="ta-products__empty">' + tr('no_data','No data for this round.') + '</p>');
      if (statusEl) { statusEl.textContent = tr('opens_soon','OPENS SOON'); statusEl.className = 'ta-countdown__label'; }
      if (hrEl) hrEl.textContent = '--'; if (minEl) minEl.textContent = '--'; if (secEl) secEl.textContent = '--';
      if (stockEl) stockEl.textContent = '';
      if (slotsEl) slotsEl.innerHTML = '';
      return;
    }

    if (match.type === 'active') {
      var round = match.round;
      var state = getEffectiveState(round);

      // Render slot schedule
      renderSlots(round);

      if (statusEl) {
        var allSoldOut = round.products && round.products.length > 0 && round.products.every(function (p) {
          if (p.soldOut) return true;
          var avail = 0;
          if (p.variants) p.variants.forEach(function (v) { avail += (v.available || 0); });
          return avail <= 0;
        });

        var sectionLabel = tr('opens_soon','OPENS SOON');
        if (state === 'live' && allSoldOut) sectionLabel = tr('sold_out','SOLD OUT');
        else if (state === 'live') sectionLabel = tr('live_now', '\u25CF LIVE NOW');
        else if (state === 'closing') sectionLabel = tr('closing', '\u25CF CLOSING');
        else if (state === 'pre' || state === 'waiting' || state === 'closed') {
          // Find next open time — could be today's round or upcoming
          var nextDrop = null;
          if (state === 'pre' && round.openAt) {
            nextDrop = { openAt: round.openAt };
          } else if (state === 'waiting' && round.nextOpenAt) {
            nextDrop = { openAt: round.nextOpenAt };
          } else {
            nextDrop = findNextUpcoming(currentData);
          }
          if (nextDrop && nextDrop.openAt) {
            sectionLabel = tr('next_open_in', 'NEXT DROP IN');
          } else {
            // Last round — hide TA section
            el.querySelector('.ta-countdown')?.setAttribute('style', 'display:none');
            el.querySelector('.ta-products')?.setAttribute('style', 'display:none');
            sectionLabel = '';
          }
        }
        statusEl.textContent = sectionLabel;
        statusEl.className = 'ta-countdown__label' + (state === 'live' && !allSoldOut ? ' is-live' : '');
      }

      // Countdown target depends on effective state
      if (state === 'waiting') {
        startCountdown({ nextOpenAt: round.nextOpenAt }, 'waiting');
      } else if (state === 'closed') {
        var nextUpForCountdown = findNextUpcoming(currentData);
        if (nextUpForCountdown && nextUpForCountdown.openAt) {
          startCountdown({ openAt: nextUpForCountdown.openAt }, 'pre');
        } else {
          startCountdown(round, state);
        }
      } else {
        startCountdown(round, state);
      }

      if (stockEl) {
        var cap = round.capPerVariant || 11;
        if (state === 'pre' || state === 'closed' || state === 'waiting') {
          var nextDropStock = null;
          if (state === 'pre' && round.openAt) nextDropStock = { openAt: round.openAt };
          else if (state === 'waiting' && round.nextOpenAt) nextDropStock = { openAt: round.nextOpenAt };
          else nextDropStock = findNextUpcoming(currentData);

          if (nextDropStock && nextDropStock.openAt) {
            var nextOpenDate = formatDateShort(nextDropStock.openAt);
            var todayStr = today();
            var todayShort = parseInt(todayStr.split('-')[1]) + '/' + parseInt(todayStr.split('-')[2]);
            var dayLabel = nextOpenDate === todayShort
              ? tr('label_today', 'TODAY')
              : tr('label_tomorrow', 'TOMORROW');
            var scheduleHtml = '<span class="ta-next-schedule">' + dayLabel + ' ' + tr('next_open_at', '11:11 (GMT+8)') + '</span>';
            if (state === 'closed' || state === 'waiting') {
              scheduleHtml += '<br><span class="ta-closed-note">' + tr('closed_today', "Today's drop is closed") + '</span>';
            }
            stockEl.innerHTML = scheduleHtml;
          } else {
            stockEl.textContent = '';
          }
        } else {
          var stockText = cap + ' ' + tr('units_per_day','units shared across all rounds today');
          if (round.inventoryPolicy === 'daily_shared' && round.slots && round.slots.length > 1) {
            stockText += ' \u00B7 ' + tr('shared_stock', 'Inventory is shared across all rounds today');
          }
          stockEl.textContent = stockText;
        }
      }
      renderProductCards(round);
    } else if (match.type === 'upcoming') {
      clearInterval(countdownTimer);
      if (slotsEl) {
        // Show upcoming slot schedule if available
        if (match.round.slots && match.round.slots.length > 1) {
          renderSlots(match.round);
        } else {
          slotsEl.innerHTML = '';
        }
      }
      if (statusEl) { statusEl.textContent = tr('opens_soon','OPENS SOON'); statusEl.className = 'ta-countdown__label'; }
      var openAt = match.round.openAt || match.round.open_at;
      if (openAt) startCountdown({ openAt: openAt, state: 'pre' }, 'pre');
      else { if (hrEl) hrEl.textContent = '--'; if (minEl) minEl.textContent = '--'; if (secEl) secEl.textContent = '--'; }
      if (stockEl) stockEl.textContent = '';
      renderUpcomingProducts(match.round);
    } else if (match.type === 'past') {
      clearInterval(countdownTimer);
      if (slotsEl) slotsEl.innerHTML = '';
      if (statusEl) { statusEl.textContent = tr('ended','ENDED'); statusEl.className = 'ta-countdown__label'; }
      if (hrEl) hrEl.textContent = '00'; if (minEl) minEl.textContent = '00'; if (secEl) secEl.textContent = '00';
      if (stockEl) stockEl.textContent = '';
      showLoading(false);
      if (dynamicGrid) replaceProductGrid('<p class="ta-products__empty">' + tr('round_ended', 'This round has ended.') + '</p>');
    }
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      userSelectedTab = i;
      tabs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      showTabContent(i);
    });
  });

  // GWP gauge
  var gwpFill = el.querySelector('[data-gwp-fill]'), gwpPointer = el.querySelector('[data-gwp-pointer]'), gwpRemaining = el.querySelector('[data-gwp-remaining]'), gwpGauge = el.querySelector('[data-gwp-gauge]');
  var gwpMin = el.querySelector('[data-gwp-min]'), gwpMax = el.querySelector('[data-gwp-max]'), gwpDesc = el.querySelector('[data-i18n="gwp_desc"]');
  function formatGwpMoney(cents) {
    return '$' + Number((cents / 100).toFixed(2)) + ' USD';
  }
  function renderGwpGauge(state) {
    var usd = state.thresholdUsd || parseInt(gwpGauge.dataset.gwpThresholdUsd || '120', 10);
    if (gwpMin) gwpMin.textContent = formatGwpMoney(0);
    if (gwpMax) gwpMax.textContent = formatGwpMoney(usd * 100);
    if (gwpDesc) gwpDesc.textContent = tr('gwp_desc', 'Free gift automatically added when you spend $120 USD').replace(/\$120(?: USD)?/g, formatGwpMoney(usd * 100));
    if (gwpFill) gwpFill.style.width = (state.progress || 0) + '%';
    if (gwpPointer) gwpPointer.style.left = (state.progress || 0) + '%';
    gwpGauge.setAttribute('data-gwp-status', state.status);
    if (gwpRemaining) gwpRemaining.textContent = window.VerishGwp ? window.VerishGwp.text(state, t, function (remaining) {
      return formatGwpMoney(remaining / state.rate);
    }, 'free_unlocked') : tr('gwp_unavailable', 'Gift status unavailable');
  }
  if (gwpGauge) {
    if (window.VerishGwp) window.VerishGwp.subscribe(renderGwpGauge);
    else renderGwpGauge({ status: 'unavailable', progress: 0 });
  }

  // Expose current state for PDP badge script
  window.__taCurrentState = function () {
    if (!currentData || !currentData.round) return null;
    return {
      state: getEffectiveState(currentData.round),
      round: currentData.round
    };
  };

  // Slider nav
  var prevBtn = el.querySelector('[data-ta-nav="prev"]');
  var nextBtn = el.querySelector('[data-ta-nav="next"]');
  function updateNavState() {
    if (!dynamicGrid || !prevBtn || !nextBtn) return;
    prevBtn.disabled = dynamicGrid.scrollLeft <= 0;
    nextBtn.disabled = dynamicGrid.scrollLeft + dynamicGrid.offsetWidth >= dynamicGrid.scrollWidth - 2;
  }
  function scrollSlider(dir) {
    if (!dynamicGrid) return;
    var cardW = dynamicGrid.querySelector('.ta-products__item');
    var amount = cardW ? cardW.offsetWidth + 20 : 300;
    dynamicGrid.scrollBy({ left: dir * amount, behavior: 'smooth' });
    setTimeout(updateNavState, 400);
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { scrollSlider(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollSlider(1); });
  if (dynamicGrid) dynamicGrid.addEventListener('scroll', updateNavState);

  showAll();
  showLoading(true);
  fetchAndRender();
  pollTimer = setInterval(fetchAndRender, POLL_INTERVAL);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearInterval(pollTimer); clearInterval(countdownTimer); }
    else { fetchAndRender(); pollTimer = setInterval(fetchAndRender, POLL_INTERVAL); }
  });
})();
